<script setup>
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import SidenavItem from "./SidenavItem.vue";
import router from "../../router";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const showModal = ref(false);

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

const CerrarSesion = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
  router.push({ name: "Login" });
};
</script>

<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100 bg-conit pb-4 mt-4"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/inicio"
          :class="getRoute() === 'inicio' ? 'active' : ''"
          :navText="'Inicio'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-white text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/miscursos"
          :class="getRoute() === 'miscursos' ? 'active' : ''"
          :navText="'Mis Cursos'"
        >
          <template v-slot:icon>
            <i class="ni ni-books text-white text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/calendario"
          :class="getRoute() === 'Calendario' ? 'active' : ''"
          :navText="isRTL ? 'حساب تعريفي' : 'Calendario'"
        >
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-white text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/miscertificados"
          :class="getRoute() === 'miscertificados' ? 'active' : ''"
          :navText="'Certificados'"
        >
          <template v-slot:icon>
            <i class="ni ni-badge text-white text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/notificaciones"
          :class="getRoute() === 'misnotificaciones' ? 'active' : ''"
          :navText="'Notificaciones'"
        >
          <template v-slot:icon>
            <i class="bi bi-bell-fill text-white text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/perfil"
          :class="getRoute() === 'Perfil' ? 'active' : ''"
          :navText="isRTL ? 'حساب تعريفي' : 'Perfil'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-white text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/soporte"
          :class="getRoute() === 'Soporte' ? 'active' : ''"
          navText="Soporte"
        >
          <template v-slot:icon>
            <i class="ni ni-headphones text-white text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item mt-auto text-center">
        <div class="btn btn-danger" style="margin-top: 80%">
          <i class="ni ni-button-power text-white text-sm" style="margin-right: 10px;"></i>
          <a href="#" @click.prevent="showModal = true" class="text-white">Cerrar Sesión</a>
        </div>
      </li>
    </ul>
  </div>

  <!-- Modal Fuera del Sidebar -->
  <teleport to="body">
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-box">
        <h5 class="mb-3">¿Estás seguro que deseas cerrar sesión?</h5>
        <div class="modal-buttons">
          <button class="btn btn-secondary" @click="showModal = false">Cancelar</button>
          <button class="btn btn-danger" @click="CerrarSesion">Aceptar</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.modal-box {
  background-color: #fff;
  border-radius: 12px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.modal-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
}
</style>
